import React, { Component } from 'react';
import { string, func, oneOf, shape, any, objectOf, obj } from 'prop-types';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { DateRange, Schedule } from '@material-ui/icons';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { withStyles } from '@material-ui/core/styles';

import ToggleButtonGroup from '../../../ToggleButtonGroup';

import classNames from 'classnames';
import styles from "./styles.scss";

class TimeRangeSelector  extends Component {
  static propTypes = {
    className: string,
    classes: shape({any}),
    onTimeSelectionChange: func,
    selectedRange: oneOf(['hourly', 'daily', 'weekly', 'monthly', 'byDayOfWeek', 'byDayPart']),
    options: objectOf(shape({
      byDayPart: obj,
      hourly: obj,
      byDayOfWeek: obj,
      daily: obj
    }))
  }

  static defaultProps = {
    selectedRange: 'byDayPart',
    options:
      {
        byDayPart: {
        value: 'byDayPart',
        label: 'By Daypart',
        icon: <ScheduleIcon style={{fontSize: '18px'}} />
        },
        hourly: {
          value: 'hourly',
          label: 'By Hour',
          icon: <Schedule style={{fontSize: '18px'}}/>
        },
        byDayOfWeek: {
          value:'byDayOfWeek',
          label: 'By Day of Week',
          icon: <DateRange style={{fontSize: '18px'}}/>
        },
        daily: {
          value: 'daily',
          label: 'By Date',
          icon: <DateRange style={{fontSize: '18px'}}/>
        }
      }
  }

  handleDropdownChange = event => {
    const selectedValue = event.target.value;
    this.handleSelectionChange(selectedValue);
  }

  handleButtonGroupChange = value => {
    this.handleSelectionChange(value);
  }

  handleSelectionChange = value => {
    const {
      selectedRange,
      onTimeSelectionChange
    } = this.props;

    selectedRange !== value && onTimeSelectionChange && onTimeSelectionChange(value);
  }

  drawTimeSelector() {
    const {
      classes,
      selectedRange,
      options
    } = this.props;

    const selectedOption =
      selectedRange === 'weekly' || selectedRange === 'monthly' ? options['daily'] :
      options[selectedRange];

    const selectedValue = selectedOption.value;

    return (
      <FormControl className={styles.dropdown}>
        <Select
          value={selectedValue}
          className={styles.selectItem}
          onChange={this.handleDropdownChange}
          inputProps={{ classes: { icon: classes.arrowDropDown } }}
          /*eslint-disable */
          renderValue={function(){
            return (
              <div className={styles.labelContainer}>
                {selectedOption.icon}
                <span className={styles.iconLabel} data-test={'selectedTimeRange_' + selectedOption.label}>{ selectedOption.label }</span>
              </div>
            );
          }}
          /*eslint-enable */
          data-test="timeRangeSelectBox"
        >
          {
            Object.values(options).map((entry) => <MenuItem value={entry.value} key={entry.value} data-test={'selectTimeRangeOption_' + entry.label}>{entry.label}</MenuItem>)
          }
        </Select>
      </FormControl>
    );
  }

  drawDateOptions() {
    const dateRangeOptions = [{
      value: 'daily',
      label: 'Daily'
    }, {
      value: 'weekly',
      label: 'Weekly'
    }, {
      value: 'monthly',
      label: 'Monthly'
    }];

    const { selectedRange }  = this.props;

    return (
      <ToggleButtonGroup
        buttons={dateRangeOptions}
        selectedValue={selectedRange}
        onSelectionChange={this.handleButtonGroupChange}
        className={classNames({[styles.hidden]: selectedRange === 'hourly' || selectedRange === 'byDayOfWeek' || selectedRange === 'byDayPart' })}
      />
    );
  }
  
  render () {
    const {
      className
    } = this.props;

    return (
      <div className={classNames(styles.timeRangeSelector, className)}>
        {this.drawTimeSelector()}
        {this.drawDateOptions()}
      </div>
    );
  }
}


const muiStyles = {
  arrowDropDown: {
    color: '#2196f3'
  }
};

export default withStyles(muiStyles)(TimeRangeSelector);